module.exports = __webpack_public_path__ + "img/Elements site web copie ecran.6b7dfcc5.png";